import { PreventionActionStatus } from "@/entities/prevention-action/model/prevention-action.types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { getPreventionActionStatusLabelFull } from "../model/prevention-action.formatter"
import { PREVENTION_MEASURE_ICONS } from "../model/prevention-action.icons"
import getColor from "@/utils/get-color.utils"

interface Props {
  currentStatus: PreventionActionStatus
  isReadonly?: boolean
  isOverdue?: boolean
  isToPlan?: boolean
  onOpen?: () => void
}

export default function PreventionActionStatusCheck({ currentStatus, isReadonly, isOverdue, isToPlan, onOpen }: Props) {
  const isDone = currentStatus === "done"
  const isLate = isOverdue && !isDone
  const needsDate = isToPlan && !isDone
  const icon = PREVENTION_MEASURE_ICONS[isDone ? "in-place" : isLate ? "overdue" : needsDate ? "to-plan" : "planned"]
  //Jaune de la palette assombri : lisible en texte sur fond blanc, contrairement a getColor("yellow")
  const color = needsDate ? "#8A6D00" : getColor(isLate ? "orange" : "blue")

  return (
    <button
      type="button"
      aria-label={needsDate ? "Planifier les dates de la mesure" : "Modifier le statut de la mesure"}
      disabled={isReadonly}
      className={`${isReadonly ? "" : "_hover"} flex shrink-0 items-center gap-[7px] border-0 bg-transparent p-0`}
      style={{ color }}
      onClick={(event) => {
        event.stopPropagation()
        if (!isReadonly) onOpen?.()
      }}>
      <span className="flex w-[28px] shrink-0 justify-center">
        <FontAwesomeIcon className="text-[28px]" icon={icon} />
      </span>
      {/* 64px : le libelle passe naturellement sur deux lignes, comme avant */}
      <span className="w-[64px] text-left text-sm font-bold leading-tight">
        {getPreventionActionStatusLabelFull(currentStatus, isOverdue, isToPlan)}
      </span>
    </button>
  )
}
